// src/components/common/JsonSchemaFormSelector.jsx
import React from "react";
import JsonSchemaForm from "./JsonSchemaForm";
import JsonSchemaFormMUI from "./JsonSchemaFormMUI";
import JsonSchemaFormFluent from "./JsonSchemaFormFluent";

// opzioni disponibili: "HTML", "MUI", "FLUENT"
const FORM_STYLE = "FLUENT";

export default function JsonSchemaFormSelector(props) {
  switch (FORM_STYLE) {
    case "MUI":
      return <JsonSchemaFormMUI {...props} />;
    case "FLUENT":
      return <JsonSchemaFormFluent {...props} />;
    default:
      return <JsonSchemaForm {...props} />;
  }
}
